import React from 'react';
import ReactModal from 'react-responsive-modal';

/**
 * Modal.defaultProps = {
  closeOnEsc: true,
  closeOnOverlayClick: true,
  onEntered: null,
  onExited: null,
  onEscKeyDown: null,
  onOverlayClick: null,
  showCloseIcon: true,
  closeIconSize: 20,
  closeIconSvgPath: closeIconSvg,
  styles: {
    modal: {
      borderRadius: 3,
      padding: 20,
      boxShadow: `0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)`
    }
  },
  children: null,
  center: false,
  animationDuration: 500,
  focusTrapped: false,
  dataTestId: null
};
 */
const Modal = (props) => <ReactModal {...props} />;
const closeIconSvg = (
  <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" />
);

export default Modal;
